import BootLoader from '../common/components/boot-loader/boot-loader';
import Button from '../common/components/button/button';
import { useAuth } from '../global/contexts/auth/auth';

import './styles/app-gate.css';

export default function AppGate({ children }) {
    const { initializing, bootError, retry } = useAuth();
    if (initializing) return <BootLoader />;
    if (bootError) {
        return (
            <main className="app-gate" role="alert">
                <h1 className="app-gate__title">No pudimos conectar con Mastermind</h1>
                <p className="app-gate__text">Revisa tu conexión o el endpoint configurado y vuelve a intentarlo.</p>
                <Button variant="primary" onClick={retry}>Reintentar</Button>
            </main>
        );
    }
    return children;
}
